module.exports = __webpack_public_path__ + "img/empty-search.09619219.svg";